<template>
    <li class="header--account" @click="isOpen = !isOpen" v-click-outside="handleClickOutside" v-if="hasUserType">
        <i class="fal fa-user" />

        <ul v-if="isOpen">
            <router-link v-for="(link, index) in routes" :key="`router-link-account-${index}`" tag="li" :to="{ name: link.name }">
                <a href="#">{{ link.label }}</a>
            </router-link>
            <li v-if="hasAuthenticatedParent(1)" @click="returnAsParent(1)">
                <a href="#" v-if="hasAuthenticatedParent(2)">{{ t('nav.ghost.return_to_reseller') }}</a>
                <a href="#" v-else-if="hasAuthenticatedParent(1)">{{ t('nav.ghost.return_to_admin') }}</a>
            </li>
            <li v-if="hasAuthenticatedParent(2)" @click="returnAsParent(2)">
                <a href="#">{{ t('nav.ghost.return_to_admin') }}</a>
            </li>
        </ul>
    </li>
</template>
<script>
import CustomStorage from '@glenngijsberts/customstorage';
import Ghost from '@/classes/Ghost';
import handleError from '@/helpers/error';
import { getUserType } from '@/helpers/auth';

export default {
    name: 'AccountMenu',

    props: {
        routes: {
            type: Array,
            required: false,
        },
    },

    data() {
        return {
            isOpen: false,
        };
    },

    methods: {
        handleClickOutside() {
            this.isOpen = false;
        },

        hasAuthenticatedParent(depth) {
            let currentAuth = this.auth;
            let i = 0;

            while (i < depth) {
                if (!Object.prototype.hasOwnProperty.call(currentAuth, 'parent')) {
                    return false;
                }

                currentAuth = currentAuth.parent;

                i += 1;
            }

            return true;
        },

        returnAsParent(depth) {
            Ghost.logout(depth)
                .then(() => {
                    this.$router.go();

                    // fix for safari browsers
                    window.location.reload();
                })
                .catch((error) => {
                    handleError({
                        error,
                        message: this.$translate.text('alert.whoops'),
                    });
                });
        },

    },

    computed: {
        auth() {
            return CustomStorage.get('auth');
        },

        hasUserType() {
            const userType = getUserType();
            if (userType !== null) {
                return true;
            }
            return false;
        },
    },
};
</script>
